import { ScopeOfWorkEnum, OrderEventStatusEnum } from '@/generated/graphql'

export const SCOPE_OF_WORK_EXTENDED_OPTIONS: Array<{ value: ScopeOfWorkEnum; label: string; desc: string }> = [
  { value: ScopeOfWorkEnum.Labour,        label: 'Labour',           desc: 'Service only, client provides materials' },
  { value: ScopeOfWorkEnum.WithMaterials, label: 'Labour + Materials', desc: 'Vendor brings service and materials' },
  { value: ScopeOfWorkEnum.SupplyOnly,    label: 'Supply Only',      desc: 'Vendor delivers goods, no service' },
  { value: ScopeOfWorkEnum.ServiceOnly,   label: 'Service Only',     desc: 'Manpower only, no materials' },
]

// Raw unit values — no empty sentinel
const UNIT_VALUES = ['kg', 'gm', 'bottle', 'piece', 'box', 'pack', 'roll', 'liter', 'pax'] as const
export type UnitValue = (typeof UNIT_VALUES)[number]

// For SelectInput inside modals (with empty "Select unit" option)
export const UNIT_OPTIONS = [
  { value: '', label: 'Select unit' },
  ...UNIT_VALUES.map(v => ({ value: v, label: v })),
]

// For InlineNumberInput / bare select contexts (no empty sentinel)
export const UNIT_OPTIONS_BARE = UNIT_VALUES.map(v => ({ value: v, label: v }))

// Gujarati event type options (shared by EventTypeInput + TemplateModal criteria)
export const EVENT_TYPE_OPTIONS = [
  'સગાઇ',
  'ગીતનો નાસ્તો',
  'સવારનો નાસ્તો',
  'મંડપ મુહર્ત',
  'બપોરનો નાસ્તો',
  'મામેરું',
  'ગરબા',
  'લગ્ન',
  'રિસેપ્શન',
  'બર્થડે',
  'જમણવાર',
  'જાન વેલકમ',
  'વેલકમ જ્યુસ & બાઈટીંગ',
] as const

// Order/event status filter options
export const ORDER_STATUS_OPTIONS = [
  { value: 'ALL', label: 'All Status' },
  { value: OrderEventStatusEnum.Estimated, label: 'Estimated' },
  { value: OrderEventStatusEnum.PartiallyConfirmed, label: 'Partially Confirmed' },
  { value: OrderEventStatusEnum.Confirmed, label: 'Confirmed' },
  { value: OrderEventStatusEnum.Cancelled, label: 'Cancelled' },
]
